import React, { Fragment } from 'react';
import './styles.scss';
import Button from '@Common/Button';

type DrawerProps = {
    isWide: boolean;
    isMobile?: boolean;
    title: string | React.ReactNode;
    onSaveClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    saveText?: string;
    isSaveDisabled?: boolean;
    onCancelClick?: () => void;
    cancelText?: string;
    /**
     * Array of elements to render in the header menu. If elements are ReactElements with a `key`,
     * we compare to `currentDrawerKey` to hide the current one (matching the original behavior).
     */
    menuButtons?: React.ReactElement[];
    currentDrawerKey?: string | number | null;
    formButtons?: React.ReactElement[];
    customFooter?: React.ReactNode;
    children?: React.ReactNode;
};

class DrawerV6 extends React.Component<DrawerProps> {
    componentDidMount() {
        document.addEventListener('keydown', this.escFunction, false);
    }

    componentWillUnmount() {
        this.cleanUp();
        document.removeEventListener('keydown', this.escFunction, false);
    }

    private escFunction = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            this.closeClick();
        }
    };

    private cleanUp = () => {
        document.body.classList.remove('modal-open');
    };

    private saveClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.cleanUp();
        if (this.props.onSaveClick) {
            this.props.onSaveClick(event);
        }
    };

    private closeClick = () => {
        this.cleanUp();
        if (this.props.onCancelClick) {
            this.props.onCancelClick();
        }
    };

    render() {
        const { isWide } = this.props;

        const wideCheck = isWide ? ' drawer-wide' : '';
        const final = `drawerv6 active ${wideCheck}`.trim();

        return (
            <div className={final}>
                <div className='inner'>
                    <header>
                        <div className='drawer-title'>
                            {React.isValidElement(this.props.title) ? (
                                <div>{this.props.title}</div>
                            ) : (
                                <div className='drawer-title-text'>{this.props.title}</div>
                            )}
                        </div>
                        <div className='drawer-span menuButtons menuButtonGroup'>
                            {this.props.menuButtons && (
                                <Fragment>
                                    {this.props.menuButtons.map((menuButton) => {
                                        // Keep original behavior: hide the menu button whose key matches currentDrawerKey
                                        if (!this.props.currentDrawerKey || menuButton.key !== this.props.currentDrawerKey) {
                                            return menuButton;
                                        }
                                        return null;
                                    })}
                                </Fragment>
                            )}

                            <button name='close' type='button' className='btn btn-close' onClick={this.closeClick} aria-label='close popup'>
                            </button>
                        </div>
                    </header>
                    <div className='drawer-content'>
                        <div className='container'>
                            <br />
                            {this.props.children}
                        </div>
                    </div>
                    <footer>
                        {this.props.customFooter ? (
                            this.props.customFooter
                        ) : (
                            <div className='button-wrap'>
                                <Button
                                    type='button'
                                    bootstrapClass='outline-secondary'
                                    onClick={this.closeClick}
                                    text={this.props.cancelText ? this.props.cancelText : 'Cancel'}
                                />
                                {this.props.onSaveClick && (
                                    <Button
                                        type='button'
                                        bootstrapClass='primary'
                                        onClick={this.saveClick}
                                        text={this.props.saveText ? this.props.saveText : 'Save'}
                                        isDisabled={this.props.isSaveDisabled}
                                    />
                                )}
                                {this.props.formButtons ? this.props.formButtons.map((formButton) => formButton) : null}
                            </div>
                        )}
                    </footer>
                </div>
            </div>
        );
    }
}

export default DrawerV6;
